import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { IonToggle } from '@ionic/angular';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { OrderService } from '../../services/order.service';
import { LoaderService } from 'src/app/shared/services/loader.service';
import { finalize } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { ValidatorsService } from 'src/app/shared/services/validators.service';
import { TranslationService } from 'src/app/shared/services/translation.service';

export interface ICheckoutGiftCardForm {
  use: boolean;
  cardNumber: string;
  cvc: string;
  giftAmount?: number;
  remainingBalance?: number;
}

@Component({
    selector: 'store-checkout-gift-card-form',
    templateUrl: './checkout-gift-card-form.component.html',
    styleUrls: ['./checkout-gift-card-form.component.scss'],
    standalone: false
})
export class CheckoutGiftCardFormComponent implements OnInit {
  useGiftCard: boolean = false;
  form: FormGroup;
  formErrors: Map<string, string> = new Map<string, string>();

  giftCardValidate: boolean;
  giftCardError: string;

  giftAmount: number;
  @Input() subtotal: number;
  @Input() freeDelivery: any;
  @Input() deliveryPrice: number;
  @Input() total: number;
  @Input() storeId: string;
  @Output() onSubmit: EventEmitter<ICheckoutGiftCardForm> = new EventEmitter<ICheckoutGiftCardForm>();

  patternReference: any = {};

  get remainingBalance() {
    return this.total - this.giftAmount;
  }

  get giftCardMessage(): string {
    if (this.giftCardError)
      return this.giftCardError;
    return this.translationService.translate('Checkout.UseGiftCardToPay');
  }

  get giftCardPaymentMessage(): string {
    if (this.remainingBalance <= 0)
      return 'Checkout.UseGiftCardClickToPay';

    return 'Checkout.UseGiftCardRemainingBalance';
  }

  get useGiftCardToggleText(): string {
    if (this.useGiftCard)
      return 'General.Yes';
    return 'General.No';
  }

  constructor(private fb: FormBuilder,
    private orderService: OrderService,
    //private translateService: TranslateService,
    private loader: LoaderService,
    public validators: ValidatorsService,
    private translationService: TranslationService) { }

  ngOnInit() {
    /*
    this.form = this.fb.group({
      'use': [false, this.validators.formBuilderValidationInitializer(true)],
      'giftCard': ['', this.validators.formBuilderValidationInitializer(false)]
    });
    */
    this.form = this.fb.group({
      use: this.fb.control(false, {
        validators: this.validators.formBuilderValidationInitializer(true),
        updateOn: 'change'
      }),
      giftCard: this.fb.control('', {
        validators: this.validators.formBuilderValidationInitializer(false),
        updateOn: 'change'
      }),
      cvc: this.fb.control('', {
        validators: this.validators.formBuilderValidationInitializer(false),
        updateOn: 'change'
      })
    });

    /*
    this.form["patternReference"] = {
      use: null,
      giftCard: null
    };
    */
    this.patternReference = {
      use: null,
      giftCard: null
    };

    //this.validators.trackInputChange(this.form);
    this.validators.trackInputChange(this.form, this.patternReference);
  }

  onUseGiftCardChange(event: CustomEvent<IonToggle>) {
    this.useGiftCard = event.detail.checked;
  }

  onGiftCardNumberChange() {
    this.giftCardValidate = false;
  }

  async giftCardPreAuthorization() {
  
   const loader = await this.loader.create();
   await loader.present();
    if(this.freeDelivery)
    {
      if(this.freeDelivery.isAllowed)
      {
        if(this.subtotal >= this.freeDelivery.price)
        {
          this.total = this.total-this.deliveryPrice;
        }
      }
    }
      this.orderService.giftCardBalancePreAuthorization({
        amount: this.total,
        hardwareInfo: this.form.get('giftCard').value,
        cvc: this.form.get('cvc').value,
        language: this.translationService.getLanguage(),
        storeId: this.storeId
      })
        .pipe(finalize(async () => {
          await loader.dismiss();
        }))
        .subscribe((data) => {
          this.giftCardError = null;
          if (data.amount == this.total) {
            this.giftCardError = this.translationService.translate('Checkout.InvalidGiftCard');
            this.giftCardValidate = false;
            return;
          }
  
          this.giftAmount = this.total - data.amount;
  
          this.giftCardValidate = true;
  
          this.onSubmit.emit({
            use: this.form.get('use').value,
            cardNumber: this.form.get('giftCard').value,
            cvc: this.form.get('cvc').value,
            giftAmount: this.total - data.amount,
            remainingBalance: this.remainingBalance
          });
        }, (error: HttpErrorResponse) => {
          let keys = Object.keys(error.error.errors);
          this.giftCardError = error.error.errors[keys[0]][0];
        });
    }
 
  

  submit() {
    //sanitizing
    this.form.setValue(this.validators.multiSanitizerInput(this.form.value));

    if (!this.form.valid) {
      return;
    }
    this.onSubmit.emit({
      use: this.form.get('use').value,
      cardNumber: this.form.get('giftCard').value,
      cvc: this.form.get('cvc').value
    });
  }
}
